import isEqual from 'lodash.isequal';

export type SelectorMap = Record<string, (obj: any) => unknown>;

/**
 * Compares two objects using selector functions to determine which fields have changed.
 * Used for analytics tracking (Mixpanel) to identify which fields were modified on edit.
 */
export const getUpdatedFieldKeys = (original: any, updated: any, selectors: SelectorMap): string[] => {
  try {
    if (!original || !updated || typeof selectors !== 'object' || selectors === null) return [];
    const changed: string[] = [];
    for (const key of Object.keys(selectors)) {
      const sel = selectors[key];
      if (typeof sel !== 'function') continue;
      const a = sel(original);
      const b = sel(updated);
      if (!isEqual(a, b)) changed.push(key);
    }
    return changed;
  } catch (e) {
    console.warn('getUpdatedFieldKeys failed:', e);
    return [];
  }
};
